import {
  LOADING_ARRAY,
  LIST_UNIT_DEVICES_REQUEST,
  LIST_UNIT_DEVICES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> [deviceIds, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_UNIT_DEVICES_REQUEST:
      return {
        ...state,
        [action.unitId]: state[action.unitId] || LOADING_ARRAY,
      }
    case LIST_UNIT_DEVICES_RESPONSE:
      return {
        ...state,
        [action.unitId]: (action.devices || []).map((d) => d.id),
      }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
